import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { portalBasePath } from '../../utils/portalPath'

// The brand portal moved from /rmn/:brandSlug/* to /portal/:brandSlug/*.
// Old emails, bookmarks and branded-login ?redirect= values keep working
// through this prefix shim (kept indefinitely). It needs no user: a
// logged-out hit on /rmn/:slug/login lands on the branded login at the new
// path, and its ?redirect= value is rewritten by this same shim on the next
// hop.
export default function RmnPrefixRedirect() {
  const { brandSlug, '*': rest } = useParams()
  const { search } = useLocation()
  const pathname = `${portalBasePath(String(brandSlug))}${rest ? `/${rest}` : ''}`
  return <Navigate to={{ pathname, search }} replace />
}
